/**
 * PHP-injected host for php-client (agencies and other www catalogue REST).
 *
 * Distinct from `_msApiEndpoint` (this embedding host, login-auth).
 *   - app PHP: `location.origin` in local only (get-agencies mock). Hosted
 *     omits the var so php-client keeps `VITE_MS_API_ENDPOINT` (www).
 *   - www PHP: `location.origin` in local only (same JWT reason). Hosted
 *     omits the var so php-client keeps `VITE_MS_API_ENDPOINT`.
 *
 * Hosted Amplify / `pnpm dev` never set `_msPhpClientEndpoint`; callers keep
 * the configured Vite base (`VITE_MS_API_ENDPOINT`).
 */
export function resolvePhpClientEndpoint(configuredBase: string): string {
  return globalThis.window?._msPhpClientEndpoint || configuredBase;
}
